var map = {
	"./1.png": 2943,
	"./2.png": 2944,
	"./3.png": 2945,
	"./4.png": 2946
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 377;



//////////////////
// WEBPACK FOOTER
// ./assets/images/ribbons/letters .\.png*
// module id = 377
// module chunks = 0